import { ReferenceObject, ReferenceObjectListItem } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * FOR TESTING OR DEVELOPMENT USE ONLY - NOT FOR PRODUCTION USE.
 * =============================================================
 * Provides CRUD access for Reference Objects.
 * The implementation is based on the current development conventions.
 * The reference objects have no meaning or use outside development or testing environments, and they
 * should not be used in production for any business purpose.
 */
export class ReferenceObjects extends CrudApiBase<ReferenceObject, ReferenceObjectListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/reference-objects";

  constructor(ajax: Ajax) {
    super(ajax);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): ReferenceObject {
    return {
      header: {},
      events: [],
      usecase: {
        data: {}
      },
      workflowData: {
        events: [],
      },
     };
  }
}
